<template>
    <div class="web-home">
        <!-- 1. 顶部操作栏 -->
        <web-famous-pedia-top-bar></web-famous-pedia-top-bar>
        <!-- 2. 主要内容部分 -->
        <div class="web-no-result-content">
            <p>抱歉，没有找到与 “<span class="web-no-result-name">{{curText}}</span>” 相关的名人八字。</p>
            <div class="web-no-result-sub-content">
                <p>百科尚未收录名人“<span class="web-no-result-name">{{curText}}</span>” </p>
                <p>欢迎您来创建录入名人八字，与广大易友分享进行学习交流。<button class="web-no-result-create" @click="clickCreate">我来录入</button></p>
            </div>
            <p class="gray">名人百科建议您检查输入的文字是否有误，或者尝试搜索别的名字。</p>
        </div>
        <!-- 3. copyright -->
        <web-copy-right></web-copy-right>
    </div>
</template>

<script>
import WebFamousPediaTopBar from '../../layouts/web/WebFamousPediaTopBar.vue'
import WebCopyRight from '../../layouts/web/WebCopyRight.vue'
import { SHARE } from '../../modules/share'
export default {
    name: 'WebNoResult',
    components: { WebFamousPediaTopBar, WebCopyRight },
    data() {
        return {
            curText: ''
        }
    },
    mounted() {
        this.initData();
        setTimeout(() => {
            SHARE.initConfigShare();
        }, 20);
        this.$bus.on('updateWebNoResult', this.initData);
    },
    destroyed() {
        this.$bus.off('updateWebNoResult', this.initData);
    },
    methods: {
        initData() {
            var searchPediaText = this.$store.state.famouspedia.searchPediaText;
            if(searchPediaText == '') {
                this.$router.replace('/webhome');
            }else {
                this.curText = searchPediaText;
            }
        },
        clickCreate() {
            // 我来录入要检验登录态，并且要拉取一些数据
            this.$store.dispatch('collate/resetData');
            this.$store.dispatch('collate/initSizhuCollate');
            this.$router.replace('/famouspediacreate');
        }
    }
}
</script>